import { activityAxios } from '@/axios'

/**
 * 大赛辅导页，数据
 * @param { Object } data
 */
export const getCompetitionGuidance = params => {
  return activityAxios({
    method: 'get',
    url: '/global/painting/client/getCompetitionGuidance',
    params
  })
}
